
import * as React from "react";
import { toast as sonnerToast } from "sonner";
import type { ToastProps, ToastApi } from "@/types/toast";

// Simple toast wrapper with consistent API
export const toast: ToastApi = {
  success: (message: string | { title: string; description: string }) => {
    if (typeof message === 'string') {
      return sonnerToast.success(message);
    } else {
      return sonnerToast.success(message.title, { description: message.description });
    }
  },
  error: (message: string | { title: string; description: string; variant?: string }) => {
    if (typeof message === 'string') {
      return sonnerToast.error(message);
    } else {
      return sonnerToast.error(message.title, { description: message.description });
    }
  },
  info: (message: string | { title: string; description: string }) => {
    if (typeof message === 'string') {
      return sonnerToast.info(message);
    } else {
      return sonnerToast.info(message.title, { description: message.description });
    }
  },
  warning: (message: string | { title: string; description: string }) => {
    if (typeof message === 'string') {
      return sonnerToast.warning(message);
    } else {
      return sonnerToast.warning(message.title, { description: message.description });
    }
  },
  // For components that use the more complex toast API
  // This maintains compatibility with the previous implementation
  toast: (props: ToastProps) => {
    const { variant, ...rest } = props;
    if (variant === "destructive") {
      return sonnerToast.error(props.title, { description: props.description });
    }
    return sonnerToast.success(props.title, { description: props.description });
  },
  dismiss: sonnerToast.dismiss
};

// For components that use the hook pattern
export function useToast() {
  return {
    toast: toast.toast,
    dismiss: sonnerToast.dismiss,
  };
}

export default useToast;
